<template>
  <div class="mgx_modal_panel" :class="panelClass" :style="panelStyle" @click.stop>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    width?: string
    maxWidth?: string
    height?: string
    maxHeight?: string
    minHeight?: string
    padding?: string
    background?: string
    border?: string
    shadow?: string
    radius?: string
    overflow?: string
    display?: string
    panelClass?: string | string[] | Record<string, boolean>
  }>(),
  {
    width: 'auto',
    maxWidth: 'min(960px, calc(100vw - 48px))',
    height: 'auto',
    maxHeight: 'calc(100vh - 48px)',
    minHeight: '0',
    padding: '0',
    background: 'var(--glass-panel-bg)',
    border: 'var(--panel-border-soft)',
    shadow: 'var(--shadow-panel)',
    radius: 'var(--radius-l)',
    overflow: 'hidden',
    display: 'flex',
    panelClass: undefined,
  },
)

const panelStyle = computed(() => ({
  width: props.width,
  maxWidth: props.maxWidth,
  height: props.height,
  maxHeight: props.maxHeight,
  minHeight: props.minHeight,
  padding: props.padding,
  background: props.background,
  border: props.border,
  boxShadow: props.shadow,
  borderRadius: props.radius,
  overflow: props.overflow,
  display: props.display,
}))
</script>

<style scoped lang="less">
.mgx_modal_panel {
  position: relative;
  flex-direction: column;
  contain: layout paint;
  will-change: transform, opacity;
}
</style>
